import React, { useState } from 'react'
import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'

import Anchor from '@ecm/ui/element/Anchor'
import Color from '@ecm/ui/element/Color'

type ReadMoreToggleProps = {
  children: React.ReactNode
  className?: string
  background?: string
  maxHeight: string
  fontSize?: string
  label?: string
  color?: string
  caretSize?: string
  anchorColor?: string
  whiteCaret?: boolean
  caret?: boolean
}

const ReadMoreToggle = styled(
  ({
    children,
    className,
    maxHeight,
    color,
    background,
    fontSize,
    label = 'See',
    anchorColor,
    whiteCaret,
    caret = true,
  }: ReadMoreToggleProps) => {
    const [isExpanded, setIsExpanded] = useState(false)

    const onClickButton = (e: React.SyntheticEvent) => {
      e.preventDefault()
      setIsExpanded(prevIsExpanded => !prevIsExpanded)
    }

    return (
      <Box className={`${className} ${isExpanded ? 'expanded' : ''}`}>
        {children}
        {maxHeight !== 'none' && (
          <Box
            width="100%"
            pt="2.5em"
            position="absolute"
            bottom="0"
            textAlign="center"
            sx={{
              background:
                background ??
                `linear-gradient(180deg, rgba(240, 247, 250, 0) 0%, ${
                  color ?? Color.white.normal
                } 60%)`,
            }}
          >
            <Anchor
              href=""
              onClick={onClickButton}
              caret={caret}
              whiteCaret={whiteCaret}
              fontSize={fontSize}
              color={anchorColor}
            >
              {`${label} ${isExpanded ? 'less' : 'more'}`}
            </Anchor>
          </Box>
        )}
      </Box>
    )
  }
)(({ maxHeight, caretSize }: ReadMoreToggleProps) => ({
  '&.expanded': {
    a: {
      '&:after': {
        transform: 'rotate(-90deg)',
      },
      '&:hover': {
        '&:after': {
          transform: 'rotate(-90deg)',
        },
      },
      background: 'transparent',
    },
    maxHeight: '2000px',
    paddingBottom: maxHeight === 'none' ? 0 : '3em',
    transition: 'max-height 1s linear',
  },
  a: {
    '&:after': {
      transform: 'rotate(90deg)',
      transition: 'none',
    },
    '&:hover': {
      '&:after': {
        right: '10px',
        transform: 'rotate(90deg)',
      },
    },
  },
  maxHeight: maxHeight,
  overflow: 'hidden',
  position: 'relative',

  ...(caretSize && {
    'a:after': { backgroundSize: caretSize },
  }),
}))

export default ReadMoreToggle
